module.exports = __webpack_public_path__ + "img/PMS_MZ_2.63e75ea8.gif";